// @ts-nocheck

export const localeCodes =  [
  "en"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_1f79908c",
      load: () => import("#nuxt-i18n/1f79908c" /* webpackChunkName: "locale_en_46json_1f79908c" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: "en-US"
  }
]

